// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".link--_CKp7{color:#fff !important;text-decoration:none}.link--_CKp7:hover{text-decoration:underline}", "",{"version":3,"sources":["webpack://./src/gui/Apps/Admin/Pages/InstantDealsWon/Breadcrumb.module.scss"],"names":[],"mappings":"AAAA,aAAM,qBAAqB,CAAC,oBAAoB,CAAC,mBAAY,yBAAyB","sourcesContent":[".link{color:#fff !important;text-decoration:none}.link:hover{text-decoration:underline}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"link": "link--_CKp7"
};
export default ___CSS_LOADER_EXPORT___;
